const GlobalDataSummary = (props) => {
  return (
    <div
      className="p-6 pb-8 bg-white w-3/4 rounded-lg shadow-md"
      style={{ width: "78.6rem" }}
    >
      <h2 className="text-2xl font-bold mb-4">
        {props?.reportTitle
          ? props?.reportTitle
          : props?.report?.reportTitle?.split(" ")[0]}{" "}
        data book summary
      </h2>
      <table className="min-w-full table-auto">
        <tbody>
          <tr className="border-b">
            <td className="px-6 py-4 text-gray-700  font-semibold">
              Market revenue in {props?.firstYear}
            </td>
            <td className="px-6 py-4 text-gray-900">
              USD {props?.data?.firstValue} million
            </td>
          </tr>
          <tr className="border-b bg-gray-100">
            <td className="px-6 py-4 text-gray-700 font-semibold">
              Market revenue in {props?.lastYear}
            </td>
            <td className="px-6 py-4 text-gray-900">
              USD {props?.data?.lastValue} million
            </td>
          </tr>
          <tr className="border-b">
            <td className="px-6 py-4 text-gray-700 font-semibold">
              Growth rate
            </td>
            <td className="px-6 py-4 text-gray-900">
              {props?.data?.cagr_last && `${props?.data?.cagr_last}%`} (CAGR
              from {props?.firstYear} to {props?.lastYear})
            </td>
          </tr>
          <tr className="border-b bg-gray-50">
            <td className="px-6 py-4 text-gray-700 font-semibold bg-gray-100">
              Market segmentation
            </td>
            <td className="px-6 py-4 text-gray-900 bg-gray-100">
              Type,{" "}
              {props?.report?.allSegments &&
              props?.report?.allSegments?.length > 0
                ? [
                    ...new Set(
                      props?.report?.allSegments.flatMap(
                        (segment) => segment.segment
                      )
                    ),
                  ].join(", ")
                : "No Segments Available"}
            </td>
          </tr>
          <tr>
            <td className="px-6 py-4 text-gray-700 font-semibold">
              Historical data covered
            </td>
            <td className="px-6 py-4 text-gray-900">
              {/* {props?.firstYear}- {props?.lastYear} */}
              2022 - {props?.firstYear}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default GlobalDataSummary;
